import React from 'react';
import Home from './screens/HomeContainer';
import './App.css';

const App: React.FC = () => {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
